export const PRODUCT_TABS = {
  description: 'description',
  characteristics: 'characteristics',
  composition: 'composition',
  application: 'application',
  listOfItems: 'listOfItems',
};
